import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWkLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinejoin: "round",
	strokeMiterlimit: 2,
	clipRule: "evenodd",
	viewBox: "0 0 91 91",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.959 66.165A45.26 45.26 0 0 1-.001 45.5c0-25.112 20.388-45.5 45.5-45.5 12.858 0 24.48 5.347 32.759 13.936l-.187-.178c-6.51 14.669-20.035 20.934-22.004 20.365-1.434-.413.159-5.598 1.52-9.15 1.495-3.902 1.502-7.202.785-9.17-.581-1.596-3.284-4.125-7.108-3.78-3.012.272-3.797 2.838-4.577 5.503-1.247 4.257 4.051 14.435 1.564 18.772-1.984 3.458-14.994 10.467-16.744 7.946-4.468-6.432-2.087-14.746-7.764-13.302-4.666 1.186-7.093 11.846.002 14.971 1.342.591 5.385 1.898 4.781 3.726-.497 1.507-14.568 4.795-23.58 16.473zm82.979-37.093a45.3 45.3 0 0 1 3.061 16.427C91 70.612 70.611 91 45.5 91c-11.09 0-21.26-3.976-29.158-10.58 1.843-4.424 4.392-8.07 7.687-11.551 4.942-5.22 12.266-9.219 16.574-9.61 1.4-.129 1.313 3.808 1.656 5.01C43.652 69.143 47.38 77.4 53.548 75.2a16.8 16.8 0 0 0 4.31-2.315 9 9 0 0 0 2.246-2.378c6.238-9.691-11.41-9.5-12.476-15.778-.671-3.952 10.145-7.027 21.227-12.68 9.487-4.84 14.737-8.346 19.083-12.977"
	})
});
export default SvgWkLogo;
